<template>
<div class="contentBox">
    <div class="pageTitle">
        <h1>开票</h1>
    </div>
    <div class="invoicingbox">
        <div class="info">
            <div class="item">
                <span class="label">用户名</span>
                <el-input class="w466" v-model="invoiceUserName" />
            </div>
            <div class="item">
                <span class="label">发票形式</span>
                <el-select v-model="invoiceType" placeholder="请选择" class="w466">
                    <el-option v-for="item in invoiceTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="item" :style="{ height: '40px' }">
                <span class="label">发票抬头</span>
                <el-radio-group v-model="invoiceCompanyName">
                    <el-radio label="personal">个人</el-radio>
                    <el-radio label="company">公司</el-radio>
                </el-radio-group>
            </div>
            <div class="item">
                <span class="label">发票税号</span>
                <el-input class="w466" v-model="invoiceNumber" />
            </div>
        </div>
        <div class="info">
            <div class="item">
                <span class="label">接收手机号</span>
                <el-input class="w466" v-model="invoiceMobile" type="number"  @keydown.native="channelInputLimit" />
            </div>
            <div class="item">
                <span class="label">发票内容</span>
                <el-select v-model="invoiceCon" placeholder="请选择" class="w466">
                    <el-option v-for="item in invoiceConOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="item">
                <span class="label">发票金额</span>
                <el-select v-model="invoiceAmount" placeholder="请选择" class="w466">
                    <el-option v-for="item in invoiceAmountOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
        </div>
    </div>
    <div class="actionBtnBox">
        <button class="submitBtn">提交</button>
        <button class="resetBtn" @click="resetDate()">重置</button>
    </div>
</div>
</template>

<script>
export default {
    name: "Invoicing",
    data() {
        return {
            invoiceUserName: '',
            invoiceType: '',
            invoiceTypeOptions: [{
                value: "选项1",
                label: "增值税",
            }, {
                value: "选项2",
                label: "普通发票",
            }],
            invoiceCompanyName: "personal",
            invoiceNumber: '',
            invoiceMobile: '',
            invoiceCon: '',
            invoiceConOptions: [{
                    value: "选项1",
                    label: "黄金糕",
                },
                {
                    value: "选项2",
                    label: "双皮奶",
                },
            ],
            invoiceAmount: '',
            invoiceAmountOptions: [{
                    value: "选项1",
                    label: "100",
                },
                {
                    value: "选项2",
                    label: "200",
                },
            ],
        };
    },
    methods: {
        // 手机号禁止输入e.
        channelInputLimit(e) {
            let key = e.key
            console.log(e)
            console.log(e.key)
            // 不允许输入'e'和'.'
            if (key === 'e' || key === '.') {
                e.returnValue = false
                return false
            }
            return true
        },

        // 重置事件
        resetDate(){
            this.invoiceUserName = '';
            this.invoiceType = '';
            this.invoiceCompanyName = 'personal';
            this.invoiceNumber = '';
            this.invoiceMobile = '';
            this.invoiceCon = '';
            this.invoiceAmount = '';
        }
    },
};
</script> 

<style lang="less">
.pageTitle {
    margin-bottom: 20px;

    h1 {
        height: 20px;
        line-height: 24px;
    }
}

.invoicingbox {
    width: 1210px;
    height: 287px;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    display: flex;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: #221816;
    padding-top: 23px;

    .info {
        flex: 1;
        padding-left: 29px;

        .label {
            width: 84px;
        }

        .item {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }

        .w466 {
            width: 466px;
        }

        .el-select .el-input__inner::-webkit-input-placeholder {
            color: #33363F;
        }

        .el-select .el-input__inner::-moz-input-placeholder {
            color: #33363F;
        }

        .el-select .el-input__inner::-ms-input-placeholder {
            color: #33363F;
        }
    }

    .el-radio__inner {
        width: 20px;
        height: 20px;
        background: url("../../../assets/radioinit.svg");
        border: none;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border: none;
        background: url("../../../assets/checked.svg");
    }

    .el-radio__inner::after {
        display: none;
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: #221816;
    }
}

.actionBtnBox {
    margin-top: 16px;

    button {
        width: 110px;
        height: 40px;
        border-radius: 4px;
    }

    .resetBtn {
        background: #ffffff;
        border: 1px solid #c1c5c5;
    }

    .resetBtn:hover {
        background: #306ff6;
        color: #fff;
        border: none;
    }

    .submitBtn {
        background: #076eff;
        color: #fff;
        margin-right: 22px;
    }

    .submitBtn:hover {
        background: #4aa3f8;
    }
}
</style>